/**
 * La géométrie de la photo de profil qu'on envoie : le carré central de la photo choisie, ramené à
 * `AVATAR_MAX_SIDE` au plus. Pur, testé ; `avatarImage.web.ts` le dessine sur un canevas.
 */

/** Le côté d'un avatar envoyé : bien plus que ce qu'un écran en montre, bien moins qu'une photo de téléphone. */
export const AVATAR_MAX_SIDE = 1024

export type AvatarCrop = { sx: number; sy: number; side: number; target: number }

export function avatarCrop(width: number, height: number, maxSide: number = AVATAR_MAX_SIDE): AvatarCrop {
    const side = Math.min(width, height)
    return {
        sx: Math.floor((width - side) / 2),
        sy: Math.floor((height - side) / 2),
        side,
        target: Math.min(side, maxSide),
    }
}
